module.exports = __webpack_public_path__ + "img/image01.0216130e.jpg";